import { ArrowDownRight, TrendingUp } from 'lucide-react';

const cards = [
  {
    title: 'Tattoo Studio',
    kicker: '$2,000 sleeve quote',
    body: 'Artist hands the buyer one checkout link and books the full package same consult.',
  },
  {
    title: 'Time to Close',
    kicker: '4 days -> 4 hours',
    body: 'Financing options shown at quote handoff remove payment hesitation early.',
  },
  {
    title: 'Smart Follow-up',
    kicker: 'Buyer reopened quote',
    body: 'Team gets notified and follows up while intent is fresh.',
  },
];

export default function PersonaSection() {
  return (
    <section className="border-y border-slate-200 bg-[#f8f5ef] px-6 py-20">
      <div className="container mx-auto max-w-6xl">
        <div className="max-w-3xl">
          <p className="text-xs font-semibold uppercase tracking-[0.14em] text-slate-500">Who wins with this</p>
          <h2 className="mt-3 text-3xl font-bold text-slate-900 md:text-4xl">Proof in visuals, not paragraphs</h2>
          <p className="mt-4 text-lg text-slate-600">Real selling moments for teams that need to close high-ticket work fast.</p>
        </div>

        <div className="mt-10 grid gap-4 md:grid-cols-6">
          <article className="rounded-3xl border border-slate-200 bg-white p-6 shadow-sm md:col-span-3">
            <p className="text-xs font-semibold uppercase tracking-[0.14em] text-slate-500">{cards[0].title}</p>
            <p className="mt-3 text-3xl font-extrabold text-slate-900">{cards[0].kicker}</p>
            <p className="mt-3 text-sm leading-relaxed text-slate-600">{cards[0].body}</p>
            <div className="mt-4 rounded-2xl border border-slate-200 bg-slate-50 p-4">
              <div className="h-40 rounded-xl bg-[linear-gradient(135deg,#dbeafe,#e2e8f0)]" />
            </div>
          </article>

          <article className="rounded-3xl border border-slate-200 bg-slate-950 p-6 text-white shadow-sm md:col-span-3">
            <p className="text-xs font-semibold uppercase tracking-[0.14em] text-slate-300">{cards[1].title}</p>
            <p className="mt-3 flex items-center gap-2 text-3xl font-extrabold text-emerald-300">
              {cards[1].kicker} <TrendingUp className="h-7 w-7" />
            </p>
            <p className="mt-3 text-sm leading-relaxed text-slate-300">{cards[1].body}</p>
            <div className="mt-6 h-32 rounded-xl border border-slate-700 bg-slate-900 p-3">
              <div className="grid h-full grid-cols-8 items-end gap-1">
                {[20, 28, 26, 14, 10, 8, 6, 5].map((h, idx) => (
                  <div key={idx} className="rounded bg-emerald-400/80" style={{ height: `${h}%` }} />
                ))}
              </div>
            </div>
          </article>

          <article className="rounded-3xl border border-slate-200 bg-white p-6 shadow-sm md:col-span-6">
            <p className="text-xs font-semibold uppercase tracking-[0.14em] text-slate-500">{cards[2].title}</p>
            <p className="mt-3 text-2xl font-bold text-slate-900">{cards[2].kicker}</p>
            <p className="mt-2 text-sm text-slate-600">{cards[2].body}</p>
            <div className="mt-4 inline-flex items-center gap-2 rounded-full border border-emerald-200 bg-emerald-50 px-3 py-1.5 text-sm font-medium text-emerald-800">
              Send a follow-up now <ArrowDownRight className="h-4 w-4" />
            </div>
          </article>
        </div>
      </div>
    </section>
  );
}
